export const TIPO_ANEXO_PROFISSIONAIS_LABEL: Record<number, string> = {
  1: 'Bilhete de Identidade',
  2: 'Fotografia',
  3: 'Curriculum Vitae (CV)',
  4: 'Certificado de Habilitações Literárias',
  5: 'Certificação Profissional',
  6: 'Diploma Académico',
  7: 'Carta de Apresentação',
  8: 'Carta de Recomendação',
  9: 'Declaração de Experiência Profissional',
  10: 'Comprovativo de Residência',
  11: 'Registo Criminal',
  12: 'Carta de Condução',
  13: 'Passaporte',
  14: 'Carteira Profissional',
  15: 'Portfólio Profissional',
  16: 'Certificado de Formação Profissional',
  17: 'Declaração de Disponibilidade',
  18: 'Atestado Médico',
  19: 'Outros Documentos',
};

export function labelTipoAnexoProfissional(tipo?: number | string | null): string {
  if (tipo === null || tipo === undefined) return 'Outro Documento';
  const num = typeof tipo === 'string' ? parseInt(tipo, 10) : tipo;
  return TIPO_ANEXO_PROFISSIONAIS_LABEL[num] ?? (typeof tipo === 'string' ? tipo : `Tipo ${tipo}`);
}
